/**
 * Shared layout for editor/dashboard pages with header, sidebar and main sections
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as editorModes from 'constants/editorMode'

const App = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
`
const Body = styled.div`
  height: 100%;
  display: flex;
`
const Darken = styled.div`
  position: absolute;
  left: 0px;
  width: 10000px;
  height: 5000px;
  background-color: rgba(0, 0, 0, 0.7);
`

class Layout extends Component {

  renderDarken () {
    const { isEditorPopoverVisible, editorMode } = this.props
    if (isEditorPopoverVisible || editorMode === editorModes.PREVIEW) {
      return <Darken />
    }
  }

  render () {
    const { header, sidebar, main, footer, modal } = this.props
    return (
      <App>
        {header}
        <Body>
          {sidebar}
          {main}
          {this.renderDarken()}
        </Body>
        {footer}
        {modal}
      </App>
    )
  }
}

Layout.propTypes = {
  header: PropTypes.element.isRequired,
  sidebar: PropTypes.element,
  main: PropTypes.element.isRequired,
  modal: PropTypes.element,
  footer: PropTypes.element,
  isEditorPopoverVisible: PropTypes.bool,
  editorMode: PropTypes.string
}

const mapStateToProps = state => ({
  isEditorPopoverVisible: state.gui.isEditorPopoverVisible
})

export default connect(mapStateToProps)(Layout)



// WEBPACK FOOTER //
// ./src/components/shared/Layout.js